import React from "react";
import "./Basket_crane_rental.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Hourly_Lifting_Basket_Rental() {
  return (
    <div className="Crane_work_nationwide-page">

      {/* =====================================================
          HERO - כותרת עליונה
      ===================================================== */}

      <div className="Basket_crane_rental-hero">

        <div className="Basket_crane_rental-overlay">
          <h1>השכרת מנוף סל להרמת אדם</h1>
        </div>

      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              השכרת מנוף סל להרמת אדם
            </div>

 

       

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            השכרת מנוף סל להרמת אדם מאפשרת לבצע עבודות בגובה
            במגוון תנאים ובמקומות שבהם נדרשת גישה נוחה לאזור העבודה.
            נצר הובלות ומנופים מספקת שירותי מנוף סל להרמת אדם
            לקבלנים, חברות, עסקים, אנשי מקצוע ולקוחות פרטיים,
            בהתאם לסוג העבודה, לגובה הנדרש ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/24.jpeg"
                alt="השכרת מנוף סל להרמת אדם"
              />
            </div>

            <div className="text-box">

              <p>
                השכרת מנוף סל להרמת אדם דורשת התאמה בין סוג העבודה,
                גובה העבודה, תנאי השטח ומיקום המשאית. לפני ביצוע
                העבודה חשוב לבחון את הגובה הנדרש, אזור העבודה,
                תנאי הגישה והאפשרות להציב את המנוף במקום המתאים.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות לעבודה בגובה
                באמצעות מנוף סל, לרבות עבודות תחזוקה, התקנות,
                גיזום, שילוט, עבודות חשמל, ניקוי ועבודות נוספות
                שבהן נדרשת הרמת אדם לאזור עבודה בגובה.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            השכרת מנוף סל להרמת אדם – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל עבודה עם מנוף סל להרמת אדם מתחילה בבדיקת פרטי
              העבודה. יש להבין מה גובה העבודה, מהו סוג המשימה,
              כמה זמן נדרש המנוף ומהם תנאי השטח במקום.
            </p>

            <p>
              בנוסף יש לבחון את נקודת ההצבה של המשאית, תנאי הגישה,
              המרחב הנדרש לביצוע העבודה והגישה לאזור שבו נדרשת
              העבודה בגובה.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              מנוף סל להרמת אדם לעבודות בגובה
            </h2>

            <p>
              מנוף סל מאפשר להעלות אנשי מקצוע אל אזור העבודה
              ולבצע משימות בגובה במקומות שבהם עבודה מהקרקע
              אינה אפשרית או אינה נוחה.
            </p>

            <p>
              ניתן להשתמש במנוף סל להרמת אדם לעבודות תחזוקה,
              התקנה, תיקון, גיזום, שילוט, ניקוי, עבודות חשמל
              ועבודות נוספות בהתאם לדרישות הפרויקט.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              השכרת מנוף סל להרמת אדם לאתרי בנייה ולעסקים
            </h2>

            <p>
              באתרי בנייה, מפעלים, עסקים ומבנים פרטיים יש לעיתים
              צורך בעבודה בגובה לצורך התקנת ציוד, תחזוקת מבנים,
              שילוט, תאורה ועבודות נוספות.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי השכרת מנוף סל
              להרמת אדם לאתרי בנייה, עסקים, מפעלים ולמגוון
              נקודות ברחבי הארץ, בהתאם לצורכי הלקוח ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              מנוף סל להרמת אדם לגיזום עצים
            </h2>

            <p>
              עבודות גיזום של עצים גבוהים עשויות לדרוש גישה
              לאזורי עבודה הנמצאים בגובה. מנוף סל יכול לאפשר
              לאנשי המקצוע להגיע לאזור העבודה בהתאם לתנאי
              השטח ולמיקום העץ.
            </p>

            <p>
              לפני העבודה יש לבדוק את מיקום העץ, תנאי הגישה,
              אפשרויות הצבת המשאית והגובה הנדרש לביצוע המשימה.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              מנוף סל להרמת אדם לעבודות תחזוקה והתקנה
            </h2>

            <p>
              מנוף סל מתאים למגוון עבודות תחזוקה והתקנה בגובה,
              כגון התקנת שלטים, גופי תאורה, מצלמות, מערכות,
              ניקוי מבנים ועבודות נוספות.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את מיקום המנוף ואת
              אופן הגישה לאזור העבודה כך שיתאימו למשימה ולתנאי האתר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להשכרת מנוף סל להרמת אדם?
            </h2>

            <p>
              עבודה בגובה דורשת תכנון מוקדם, התאמת ציוד מתאים
              ובדיקה של תנאי השטח. תכנון נכון יכול לסייע בביצוע
              העבודה בצורה מסודרת ובהתאם לדרישות הפרויקט.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון מנוף הסל
              לסוג העבודה, לגובה הנדרש, לתנאי הגישה ולדרישות
              הלקוח.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – השכרת מנוף סל להרמת אדם בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי השכרת מנוף
              סל להרמת אדם לעבודות בגובה לקבלנים, חברות, עסקים,
              אנשי מקצוע ולקוחות פרטיים. השירות ניתן בהתאם
              לסוג העבודה, לגובה הנדרש ולתנאים הקיימים בשטח.
            </p>

            <p>
              צריכים מנוף סל להרמת אדם? צרו איתנו קשר, ספרו לנו
              מה גובה העבודה, מה סוג המשימה והיכן היא מתבצעת,
              ונבחן עבורכם את פתרון העבודה המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Hourly_Lifting_Basket_Rental"
              className="link-right"
            >
         השכרת סל הרמה לפי שעה
            </Link>

            <Link
              to="/Basket_crane_rental"
              className="link-left"
            >
השכרת מנוף סל            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
